module.exports = __webpack_public_path__ + "static/img/Simple-Line-Icons.2fe2efe.svg";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.svg
// module id = 2223
// module chunks = 1